<template>
  <div class="rules">
    <h4 class="headtitle">{{$t('Registeranaccount')}}:</h4>
    <div style="margin-bottom:50px;font-size:20px" v-if="(ists==true)">{{$t('tis')}}</div>
    <div class="boxss" v-if="ists==false">
      <el-form
        ref="regForm"
        :label-position="labelPosition"
        label-width="80px"
        :model="formLabelAlign"
        :rules="rules"
      >
        <!-- <el-form-item prop="regionPhone">
          <div style="display: flex; align-items: center">
            <span>*</span>
            <p>{{$t('CountryRegion')}}</p>
          </div>
          <el-phone-number-input
            v-model="formLabelAlign.regionPhone"
          ></el-phone-number-input>
          
          <el-input v-model="formLabelAlign.name"></el-input>
        </el-form-item> -->
        <el-form-item prop="phone">
          <div style="display: flex; align-items: center">
            <span>*</span>
            <p>{{$t('Phonenumber')}}</p>
          </div>
          <div class="phone-box">
            <country-select style="flex:1" @input="countryInput"></country-select>
            <span class="line"></span>
            <el-input
            style="flex:3.2"
            v-model="formLabelAlign.phone"
            :placeholder="$t('Phonenumberbody')"
          ></el-input>
          </div>
          
        </el-form-item>
        <el-form-item prop="verifyCode">
          <div style="display: flex; align-items: center">
            <span>*</span>
            <p>{{$t('Captcha')}}</p>
          </div>
          <div style="display: flex; align-items: center">
            <el-input
              v-model="formLabelAlign.verifyCode"
              :placeholder="$t('pleaseenterverificationcode')"
            ></el-input>
            <el-button
              @click.stop="time == -1 ? sendMsg() : ''"
              class="sendmsg"
              style="margin-left: 12px"
              >{{ time == -1 ? $t('Sendtheverificationcode') : time + $t('secondsleft') }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item prop="mailbox">
          <div style="display: flex; align-items: center">
            <span>*</span>
            <p>E-mail</p>
          </div>
          <el-input
            v-model="formLabelAlign.mailbox"
            :placeholder="$t('PleaseenterEmail')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <div style="display: flex; align-items: center">
            <span>*</span>
            <p>{{$t('Password')}}</p>
          </div>
          <el-input
            v-model="formLabelAlign.password"
            show-password
            :placeholder="$t('Pleaseenterpassword')"
            type="password"
          ></el-input>
          <div class="sm">{{$t('digipasswordcassensitive')}}</div>
        </el-form-item>
        <el-form-item prop="repassword">
          <div style="display: flex; align-items: center">
            <span>*</span>
            <p>{{$t('ConfirmPassword')}}</p>
          </div>
          <el-input
            v-model="formLabelAlign.repassword"
            type="password"
            show-password
            :placeholder="$t('Pleaseconfirmyourpassword')"
          ></el-input>
        </el-form-item>

        <div class="choose">
          <el-checkbox
            v-model="formLabelAlign.isReaded"
            size="medium"
          ></el-checkbox>
          {{$t('readandaccept')}}<span class="btn-color">{{$t('RegistrationEntryAgreement')}}</span
          >及<span class="btn-color">{{$t('LegalNotices')}}</span>
        </div>

        <div style="position: relative">
          <div class="button-s" @click="register">{{$t('register')}}</div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  ElPhoneNumberInput,
  mobileValidator,
  phoneNumberValidator,
} from "el-phone-number-input";
import CountrySelect from "./countrySelect.vue";
export default {
  components: {
    ElPhoneNumberInput,
    CountrySelect
  },
  data() {
    var checkOther = (rule, value, callback) => {
      if (value.callingCode == "" || value.callingCode == undefined) {
        callback(new Error(this.lang=='zh'? "请选择国家/地区":'Please select a country/region'));
      } else {
        callback();
      } 
    };
    var checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.lang=='zh'?"密码不能为空":'Password cannot be empty'));
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error(this.lang=='zh'?"密码长度在6位与16位之间":'Password length is between 6 and 16 bits'));
      }
      else if(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(value)){
        callback();
      }
      else {
        callback(new Error(this.lang=='zh'?'密码必须包含数字和字母':'The password must contain numbers and letters'));
      }
    };
    var checkrePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.lang=='zh'?"密码不能为空":'Password cannot be empty'));
      } else if (value !== this.formLabelAlign.password) {
        callback(new Error(this.lang=='zh'?"两次密码不一致":'Two passwords are inconsistent'));
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.lang=='zh'?"请输入手机号":'Please enter your mobile number'));
      } else if (!/^1[23456789]\d{9}$/.test(value)) {
        callback(new Error(this.lang=='zh'?"请输入正确的手机号":'Please enter the correct mobile phone number'));
      } else {
        callback();
      }
    };
    var checkVerifyCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.lang=='zh'?"请输入验证码":'Please enter the verification code'));
      } else if (!/^[\d/.]*$/.test(value)) {
        callback(new Error(this.lang=='zh'?"验证码必须为数字值":'The verification code must be a numeric value'));
      } else {
        callback();
      }
    };
    var checkMailbox = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.lang=='zh'?"请输入邮箱地址":'Please enter email address'));
      } else if (!/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value)) {
        callback(new Error(this.lang=='zh'?"请输入正确的邮箱地址":'Please enter the correct email address'));
      } else {
        callback();
      }
    };
    return {
      labelPosition: "left",
      formLabelAlign: {
        // regionPhone: {callingCode: "86",countryCode: "CN",phoneNumber: undefined},
        region: "",
        phone: "",
        verifyCode: "",
        mailbox: "",
        password: "",
        repassword: "",
        isReaded: false,
      },
      ists:false,
      checked: true,
      loadingCode: false,
      loadingSub: false,
      timer: null,
      time: -1,
      rules: {
        // regionPhone: [{ validator: checkOther }],
        phone: [{ validator: checkPhone}], // 'blur'是鼠标失去焦点的时候会触发验证
        verifyCode: [{  validator: checkVerifyCode }],
        mailbox: [{validator: checkMailbox}],
        password: [{ validator: checkPassword }],
        repassword: [{ validator: checkrePassword }],
      },
    };
  },
  created() {
    this.formLabelAlign.region = 86
    // this.rules={
    //   // 表单验证规则
    // }
    // this.startTimer(300)
      let Currenttime =new Date();
      let date = new Date('2022-11-30');
      let time1 = date.getTime();//固定时间
      let Y = Currenttime .getFullYear()
      let M = Currenttime.getMonth() + 1;
      let D = Currenttime.getDate();
      let datadd = new Date(`${Y}-${M}-${D}`);
      let time2 = datadd.getTime();//当前时间
      if(time2>time1){
        // this.ists = true
      }
  },
  beforeDestroy() {
    this.timer = null;
  },
  methods: {
    countryInput(val){
      console.log(val)
      this.formLabelAlign.region = val
    },
    sendMsg() {
      // if(this.time>=0){
      //   return
      // }
      // console.log(this.formLabelAlign.regionPhone);

      if (
        // this.formLabelAlign.regionPhone.callingCode === ""||
        // this.formLabelAlign.regionPhone === "" ||
        // (this.formLabelAlign.regionPhone &&
        //   this.formLabelAlign.regionPhone.callingCode === undefined)
        this.formLabelAlign.region == ''
      ) {
        console.log(321)
        this.$message({
          message: this.lang=='zh'? "请选择国家/地区":'Please select a country/region',
        });
        return;
      }
      // this.formLabelAlign.region = this.formLabelAlign.regionPhone.callingCode;
      if (!this.$test.mobile(this.formLabelAlign.phone)) {
        this.$message({
          message: this.lang=='zh'? "请输入正确的手机号":'Please enter the correct mobile phone number',
        });
        return;
      }
      if (this.loadingCode) {
        return;
      }
      this.loadingCode = true;
      this.$postHttp("pc/tJudgesInfo/sendSms", {
        number: +this.formLabelAlign.phone,
        areaCode: +this.formLabelAlign.region,
      })
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.loadingCode = false;
            this.startTimer(60)
          } else {
            this.$message({
              message: res.msg,
            });
            this.loadingCode = false;
          }
        })
        .catch(() => {
          this.loadingCode = false;
        });
    },
    startTimer(time) {
      this.time = time;
      this.timer = setInterval(() => {
        this.time = this.time - 1;
        if (this.time < 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    register() {
      // console.log(this.formLabelAlign.regionPhone,'this.formLabelAlign.regionPhone');

      this.$refs.regForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          // this.formLabelAlign.region =
          // this.formLabelAlign.regionPhone.callingCode;
          console.log(this.formLabelAlign);
          
          if(!this.formLabelAlign.isReaded){
            this.$message({
               message: this.lang=='zh'? '请阅读并勾选协议':'Please read and tick the agreement',
            });
            return; 
          }
          if (this.loadingSub) {
            return;
          }
          this.loadingSub = true;
          this.$postHttp("pc/tJudgesInfo/regist", {
            phone: +this.formLabelAlign.phone,
            region: +this.formLabelAlign.region,
            password: this.formLabelAlign.password,
            mailbox: this.formLabelAlign.mailbox,
            verifyCode: this.formLabelAlign.verifyCode,
          }).then((res) => {
            console.log(res);
            if (res.success) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.loadingSub = false;
              setTimeout(()=>{
                 this.SETACTIVE(7)
            },2000)
            } else {
              // if (res.msg.indexOf("|") > 0) {
                this.$message({
                // message: this.lang=='zh'?res.msg.split("|")[0]:res.msg.split("|")[1],
                message: res.msg,
                type:"error"
              });
              // }
              
              this.loadingSub = false;
            }
          });
        } else {
          console.log("请填写正确的信息!!");
          return false;
        }
      });

      return;
    },
  },
};
</script>

<style lang="less">
// .el-input-group__prepend>
//  .el-input-group--prepend .el-input__inner{

//     display: none!important;

// }
.el-input-group > .el-input__inner {
  display: none !important;
}
.el-input-group__prepend {
  width: 100% !important;
  display: block !important;
  border-right: 1px solid #dcdfe6 !important;
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  background-color: transparent !important;
}
.el-input-group__prepend > .el-select {
  width: 100% !important;
  margin: 0 -20px !important;
}
.el-input__suffix {
  right: -36px !important;
}
.el-input__suffix-inner {
  height: 100% !important;
}

.el-button span {
  color: #333333 !important;
  font-weight: 500 !important;
}
.el-input-group__prepend > .el-select{
      margin-left: -20px!important;
}
// #333333

.rules {
  text-align: left;
  .headtitle {
    position: relative;
    font-size: 26px;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #333333;
    font-weight: 500;
    padding-left: 20px;
    margin-left: 5px;
    margin-top: 6px;
    margin-bottom: 25px;
    &:before {
      position: absolute;
      content: "";
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 24px;
      background: #6f73f4;
      border-radius: 2px 2px 2px 2px;
    }
  }
  .boxss {
    position: relative;
    .el-form-item__content {
      margin-left: 0 !important;
    }

    p {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .el-form-item__content {
      span {
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ea0000;
        display: block;
        margin-right: 6px;
      }
    }
    .el-form {
      max-width: 480px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
    .sm {
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 2;
      text-align: right;
    }
    .choose {
      text-align: center;
      margin-top: 80px;
      .el-checkbox__label {
        color: #333333;
        .btn-color {
          color: #6f73f4;
        }
      }

      .el-checkbox__inner {
        width: 20px;
        height: 20px;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #6f73f4;
      }

      .el-checkbox__inner::after {
        left: 7px;
        top: 3px;
      }
      .btn-color {
        color: #6f73f4;
        cursor: pointer;
      }
    }

    .button-s {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 220px;
      height: 56px;
      background: linear-gradient(262deg, #6a9cff 0%, #5257ff 100%);
      border-radius: 10px 10px 10px 10px;
      font-size: 24px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      margin-top: 30px;
      margin-bottom: 80px;
    }
  }
}

.phone-box{
  border-radius: 6px;
    border: 1px solid #DCDFE6;
  display: flex;
  align-items: center;
  .el-input__inner{
    border: none !important;
  }
  .line{
    height: 30px;
    width: 1px;
    background-color: #DCDFE6;
  }
}

</style>